module.exports = "https://static.energy5.com/_next/static/images/perfect2-0e078d760072200027915e1ce2f981a7.png";